import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import {
  PropType, watch, ref,
} from 'vue';
import debounce from '@/common/debounce';

export interface Marker {
  lat: number;
  lon: number;
  variant: string | true | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PropagationMap',
  props: {
  markers: {
    type: Array as PropType<Array<Marker>>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const markerString = ref('');

const debouncedUpdateMarkers = debounce(() => {
  markerString.value = props.markers.map((marker) => `&m=${marker.lat},${marker.lon},osm_bright,f87171${marker.variant === true ? ',,' : `,${marker.variant},fff`}`).join();
}, 100);

watch(() => props.markers, () => {
  if (props.markers.length === 8) {
    // Don't wait 100ms if we have all the markers
    markerString.value = props.markers.map((marker) => `&m=${marker.lat},${marker.lon},osm_bright,f87171${marker.variant === true ? ',,' : `,${marker.variant},fff`}`).join();
  } else {
    debouncedUpdateMarkers();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: `https://stadiamaps.com/static/outdoors?api_key=23fe682b-ac7c-4f2b-83db-39dcf2a8b9ac&center=27,10&zoom=0${markerString.value}&size=512x265@2x`,
    alt: "World map"
  }, null, 8, _hoisted_1))
}
}

})